import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import { Box, BoxList } from 'approot/shared/design-system/box/box.style';
import { FlexLeftAlign } from 'approot/shared/styles/flex.style';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { contentTypeLabel } from 'approot/shared/logic/content-type-label';
import { STIMULUS_RATIO } from 'approot/shared/content-card/content-card.constants';
import type { StimulusResourceFragment } from '../stimulus/stimulus.graphql.generated';
import { Heading20 } from 'approot/shared/styles/typography.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { HrStyled } from 'approot/shared/styles/decorative.style';
import CheckableCard from 'approot/shared/worksheet-card/checkbox-worksheet-card/checkable-card';
import { WorksheetCardImage } from 'approot/shared/worksheet-card/worksheet-card-image';
import { SimpleModalCardItem } from 'lib/modal/simple-modal-scrollable.style';

type Props = {
  stimulusResources: StimulusResourceFragment[];
  stimulusPages: number[];
  isAllSelected: boolean;
  onToggleAll: () => void;
  onChange: (value: string) => void;
};

const AssignStimulusCards = ({
  stimulusResources,
  stimulusPages,
  isAllSelected,
  onToggleAll,
  onChange,
}: Props) => {
  return stimulusResources && stimulusResources.length > 0 ? (
    <>
      <HrStyled />
      <Box
        $alignItems="center"
        $justifyContent="space-between"
        $marginBottom={16}
      >
        <Heading20 marginBottom={0}>Stimulus</Heading20>
        <SecondaryButton
          type="button"
          onClick={onToggleAll}
          data-selector={
            isAllSelected ? 'btn-deselect-stimulus' : 'btn-select-stimulus'
          }
        >
          {isAllSelected ? 'Deselect All Stimulus' : 'Select All Stimulus'}
        </SecondaryButton>
      </Box>
      <BoxList $gap={16} data-selector="modal-section-stimulus">
        {stimulusResources.map(stimulus => (
          <SimpleModalCardItem
            key={stimulus.id}
            data-selector="content-card-box"
          >
            <CheckableCard
              contentBadge={
                <BadgeSmallStyled>
                  <Box $gap={8} $alignItems="center">
                    <InlineSvg id={stimulus.type} width={12} height={18} />
                    {contentTypeLabel(stimulus.type)}
                  </Box>
                </BadgeSmallStyled>
              }
              content={
                <WorksheetCardImage
                  imageUrl={
                    stimulus.coverImage?.responsive?.[0]?.urls?.[0].url || ''
                  }
                  imageIsSquare
                  ratio={STIMULUS_RATIO}
                />
              }
              title={<FlexLeftAlign>{stimulus.name}</FlexLeftAlign>}
              ratio={STIMULUS_RATIO}
              fieldName="stimulusPages"
              value={stimulus.id.toString()}
              id={stimulus.id.toString()}
              checked={stimulusPages.includes(stimulus.id)}
              onChange={onChange}
            />
          </SimpleModalCardItem>
        ))}
      </BoxList>
    </>
  ) : null;
};

export default AssignStimulusCards;
